/**
 * The update notice, across the top of every page after a deploy (Jeff, 2026-10-23: staff must see
 * it). It never reloads by itself, a rep may be mid-note or mid-call, and it stays until they do.
 */
import { RefreshCw } from 'lucide-react';
import { useNewVersion } from '../../lib/version';
import { Button } from '../ui/button';

export function NewVersionBar({ stale }: { stale?: boolean }) {
  const found = useNewVersion();
  if (!(stale ?? found)) return null;
  return (
    <div role="status" className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-info/40 bg-info-soft px-4 py-2 text-body text-ink">
      <RefreshCw aria-hidden className="size-4 shrink-0 text-info" />
      <span className="font-medium">The desk was updated.</span>
      <span className="text-ink-2">Reload to get the new version. Save any note you are typing first.</span>
      <Button variant="primary" className="ml-auto h-7" onClick={() => { window.location.reload(); }}>
        Reload now
      </Button>
    </div>
  );
}
